import { render } from "./ModelSelectorCard.vue?vue&type=template&id=406d9e44&scoped=true"
import script from "./ModelSelectorCard.vue?vue&type=script&lang=js"
export * from "./ModelSelectorCard.vue?vue&type=script&lang=js"

import "./ModelSelectorCard.vue?vue&type=style&index=0&id=406d9e44&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-406d9e44"]])

export default __exports__